import React from 'react';
import Chart, { Props as ChartProps } from 'react-apexcharts';
import { merge } from 'lodash';
import { FONT_GSS_FUTURA_SEMI_BOLD } from '@monorepo/shared/src/themes/defaultTheme';

const RadialChart: React.FC<ChartProps> = ({ options, ...props }) => {
  return (
    <Chart
      type="radialBar"
      options={merge(
        {
          chart: {
            animations: { enabled: props.width === '100%' },
            fontFamily: FONT_GSS_FUTURA_SEMI_BOLD,
          },
          stroke: { lineCap: 'butt' },
          legend: { show: false },
        },
        options
      )}
      {...props}
    />
  );
};

export default RadialChart;
